import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import Box from '@mui/material/Box';
import dayjs from 'dayjs';

import ActivityCalendar from './ActivityCalendar';
import { SectionCard } from './ui';
import { Day } from '../types';
import getTimeHeatMap from '../utils/getTimeHeatmap';
import { TRUE_COLORS } from '../theme';

const SalesHeatMap = () => {
  const navigate = useNavigate();
  const yearReceiptsDaily = useSelector((state: any) => state.yearReceiptsDaily);

  const calendarData = React.useMemo<Array<Day>>(() => {
    const data = getTimeHeatMap(yearReceiptsDaily, dayjs().startOf('year'), dayjs().endOf('year'), 'daily');
    return data.sort((a, b) => (a.date > b.date ? 1 : -1));
  }, [yearReceiptsDaily]);

  return (
    <SectionCard
      title={`Actividad de ventas ${dayjs().year()}`}
      subtitle="Cada cuadro es un día. Haz clic en uno para ver su reporte."
    >
      {/* The calendar has a fixed intrinsic width; scroll horizontally on small screens. */}
      <Box sx={{ overflowX: 'auto', display: 'flex', justifyContent: { lg: 'center' }, color: TRUE_COLORS.secondary }}>
        <ActivityCalendar
          data={calendarData}
          eventHandlers={{
            onClick: () => (data: Day) => {
              navigate(`/admin/daily-report/${data.date}`);
              return true;
            },
          }}
          labels={{
            legend: { less: 'Menos', more: 'Más' },
            months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            tooltip: '<strong>{{count}} ventas</strong> · {{date}}<br/>$ {{amount}}',
            totalCount: '{{count}} ventas en {{year}}',
            weekdays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
          }}
          showWeekdayLabels
          blockMargin={4}
          blockRadius={3}
          blockSize={13}
          fontSize={12}
          color={TRUE_COLORS.primary}
        >
          <Tooltip id="react-activity-calendar-tooltip" style={{ backgroundColor: TRUE_COLORS.primary, borderRadius: 8, fontSize: 12 }} />
        </ActivityCalendar>
      </Box>
    </SectionCard>
  );
};

export default SalesHeatMap;
